import type { MetricIndexFallback } from '../service/adaptAnomaly'

export type AnomalyMetricIndexFallbackReporter = (event: MetricIndexFallback) => void

const noopReporter: AnomalyMetricIndexFallbackReporter = () => {
  /* telemetry is optional until the app composition registers a reporter */
}
let metricIndexFallbackReporter = noopReporter

/** App composition registers the vendor-backed reporter without leaking Sentry into the feature. */
export function registerAnomalyMetricIndexFallbackReporter(
  reporter: AnomalyMetricIndexFallbackReporter,
): () => void {
  metricIndexFallbackReporter = reporter
  return () => {
    if (metricIndexFallbackReporter === reporter) metricIndexFallbackReporter = noopReporter
  }
}

export function reportAnomalyMetricIndexFallback(event: MetricIndexFallback): void {
  metricIndexFallbackReporter(event)
}
